module.exports = __webpack_public_path__ + "static/media/Shamrock.6b2e7b1a.png";